<template>
    <div class="mkt" ref="table">
        <sc-search-v2
            :columns="columns"
            :result.sync="result"
            :LS="LS"
            :btn="btn"
            :size="size"
            :moreDown="false"
            @change="changeFn"
            @search="clickFn"
            @click-more="handleClickMore"
            ref="form1"
        ></sc-search-v2>
        <div style="padding-left:30px;">
            <el-button size="small" type="primary" @click="addDesigner">新增设计师</el-button>
        </div>
        <div class="tabs">
            <sc-table-v2
                :head="tableHead"
                :data="listData"
                :page="page"
                :page-hide="false"
                :pop-show="false"
                :show-add="false"
                :show-add-config="tableAddConfig"
                :table-height="tableHeightCalc"
                :read-table="true"
                :load="isLoading"
                @change="changeFn"
                @click="clickFn"
                ref="refTable"
                @pageChange="pageChange"
                @pageSizesChange="pageSizesChange"
                @rowChange="rowChange"
                @dbClick="dbClick"
                @rowClick="rowClick"
                @selection-change="selectionChange"
            >
                <template v-slot:speciality>
                    <el-table-column>
                        <template slot="header">设计师特质</template>
                        <template slot-scope="scope">
                            <div class="global-style" v-html="scope.row.speciality"></div>
                        </template>
                    </el-table-column>
                </template>
                <template v-slot:designerSaid>
                    <el-table-column>
                        <template slot="header">设计师说</template>
                        <template slot-scope="scope">
                            <div class="global-style" v-html="scope.row.designerSaid"></div>
                        </template>
                    </el-table-column>
                </template>
                <template v-slot:shortStoryText>
                    <el-table-column>
                        <template slot="header">小故事</template>
                        <template slot-scope="scope">
                            <div class="global-style" v-html="scope.row.shortStoryText"></div>
                        </template>
                    </el-table-column>
                </template>
                <template v-slot:control>
                    <el-table-column label="操作" fixed="right" width="180">
                        <template slot-scope="scope">
                            <el-button
                                type="text"
                                size="small"
                                @click="onEdit(scope.row, 'detail')"
                            >
                                编辑
                            </el-button>
                            <el-button type="text" size="small" @click="onEdit(scope.row, 'info')">
                                补充
                            </el-button>
                            <el-button type="text" size="small" @click="onEdit(scope.row, 'link')">
                                链接抓取
                            </el-button>
                            <el-button
                                type="text"
                                style="color: red"
                                size="small"
                                @click="onDel(scope.row)"
                            >
                                删除
                            </el-button>
                        </template>
                    </el-table-column>
                </template>
            </sc-table-v2>
        </div>

        <edit-dialog ref="editDialog" @handleClose="handleClose"></edit-dialog>
        <info-dialog ref="infoDialog" @handleClose="handleClose"></info-dialog>
        <link-dialog ref="linkDialog" @handleClose="handleClose"></link-dialog>
    </div>
</template>

<script>
import editDialog from './components/detail.vue';
import infoDialog from './components/info.vue';
import linkDialog from './components/link.vue';

import mixins from '@/mixins';
import getListMixin from '@/mixins/getListMixin';

import { getDesignerList, deleteDesigner } from '@/api/mkt/user.js';
export default {
    name: 'staff-index',
    mixins: [mixins, getListMixin],
    components: { editDialog, infoDialog, linkDialog },
    data() {
        return {
            tableHandle: getDesignerList,
            loading: false,
            moreDown: false,
            tableHeightCalc: window.innerHeight - 230,
            innerHeight: 0,
            LS: { 'min-width': '130px' }, //设置label宽度
            CS: { width: '500px', 'padding-right': '10px' },

            tableHead: [
                { name: '设计师ID', key: 'id', width: 160 },
                { name: '设计师姓名', key: 'name', width: 130 },
                { name: '昵称', key: 'nickName', width: 130 },
                { name: '排序值', key: 'orderSort', width: 60 },
                { name: '设计师特质', key: 'speciality', showOverflowTooltip: true },
                { name: '设计师说', key: 'designerSaid', showOverflowTooltip: true },
                { name: '小故事', key: 'shortStoryText', showOverflowTooltip: true }, //shortStoryTitle
                {
                    name: '操作',
                    key: 'control',
                    align: 'center',
                    width: '150',
                },
            ],
            columns: {
                id: {
                    name: '设计师ID',
                    type: 'input',
                    options: {
                        defaultValue: '',
                        clearable: true,
                        placeholder: '请输入',
                        options: [],
                        props: {},
                    },
                    spanCol: 1,
                },
                searchName: {
                    name: '设计师姓名/昵称',
                    type: 'input',
                    options: {
                        defaultValue: '',
                        clearable: true,
                        placeholder: '请输入',
                        options: [],
                        props: {},
                    },
                    spanCol: 1,
                },
                isSpeciality: {
                    name: '设计师特质',
                    type: 'select',
                    options: {
                        // defaultValueBase:2
                        placeholder: '请选择',
                        options: [
                            { label: '有配置', value: '0' },
                            { label: '无配置', value: '1' },
                        ],
                        props: {
                            label: 'label',
                            value: 'value',
                        },
                    },
                    spanCol: 1,
                },
                isDesignerSaid: {
                    name: '设计师说',
                    type: 'select',
                    options: {
                        // defaultValueBase: 2,
                        placeholder: '请选择',
                        options: [
                            { label: '有配置', value: '0' },
                            { label: '无配置', value: '1' },
                        ],
                        props: {
                            label: 'label',
                            value: 'value',
                        },
                    },
                    spanCol: 1,
                },
                isShortStory: {
                    name: '小故事',
                    type: 'select',
                    options: {
                        // defaultValueBase: 2,
                        placeholder: '请选择',
                        options: [
                            { label: '有配置', value: '0' },
                            { label: '无配置', value: '1' },
                        ],
                        props: {
                            label: 'label',
                            value: 'value',
                        },
                    },
                    spanCol: 1,
                },
            },
            result: {
                id: '',
                searchName: '',
                isDesignerSaid: '',
                isShortStory: '',
                isSpeciality: '',
            },
            tableAddConfig: {},

            btn: {
                oneTxt: '搜索', //第一个按钮名称
                twoTxt: '清空', //第二个按钮名称
                twoShow: true, //隐藏第二个按钮
            },
            size: 'small',
        };
    },
    created() {
        // 监控屏幕的高度
        const that = this;
        window.onresize = () =>
            (() => {
                that.innerHeight = window.innerHeight;
            })();
        this.$bus.$on('serchMore', data => {
            this.isSearchDown = data;
        });
        this.$nextTick(() => {
            this.tableHeightCalc = window.innerHeight - this.$refs.table.offsetTop - 230;
            console.log(this.tableHeightCalc, window.innerHeight, this.$refs.table.offsetTop, '38');
        });
        this.init();
    },
    watch: {
        isSearchDown: function() {
            this.tableHeightCalc = window.innerHeight - this.$refs.table.offsetTop - 230;
        },
        // 监控屏幕大小时设置高度
        innerHeight: function() {
            this.tableHeightCalc = window.innerHeight - this.$refs.table.offsetTop - 230;
        },
    },

    methods: {
        addDesigner() {
            this.$refs.infoDialog.open();
        },

        handleClickMore() {},
        handleClose() {
            this.init();
        },
        init() {
            this.queryDataMixin();
        },
        onEdit(row, type) {
            switch (type) {
                case 'detail':
                    this.$refs.editDialog.open(row);
                    break;
                case 'info':
                    this.$refs.infoDialog.open(row);
                    break;
                case 'link':
                    this.$refs.linkDialog.open(row);
                    break;
                default:
                    this.$refs.editDialog.open(row);
                    break;
            }
        },
        onDel(row) {
            this.$confirm(`您确定删除已配置好的相关内容吗?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(() => {
                deleteDesigner({ accountId: row.id }).then(() => {
                    this.$message.success('删除成功');
                    this.init();
                });
            });
        },
        rowClick() {},
        dbClick() {},
        click() {},
        changeFn(row, key) {
            console.log(row, key, '777');
            this.page.page = 1;
            this.init();
        },
        clickFn(row, type) {
            if (type == 'clear') {
                for (const key in this.result) {
                    if (typeof this.result[key] != 'string') {
                        this.result[key] = '';
                    }
                }
                this.page.page = 1;
                this.page.size = 30;
            }
            this.init();
        },
        rowChange() {},
        selectionChange() {},
    },
};
</script>
<style lang="less" scoped>
.tag-container {
    background: #fff;
}
.flex {
    display: flex;
    align-items: center;
}
.global-style {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}
</style>
